module.exports = __webpack_public_path__ + "static/media/dialog-3.996b8412.png";